export const DIMENSIONS_PER_SLIDE = 3;
